import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface TransitProps {
  id: string;
}

export const useSendOneTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      const result = await apiClient.transit.sendTransitToNcts.mutation({ params: { transitId: id } });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`Transit sent!`);
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      showErrorToast(error, `Error sending the transit!`);
    },
  });
};
